export default __webpack_public_path__ + "static/media/5osisep.572ae14e.webp";